import React, { Fragment, useEffect, useState, useCallback, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";
import { FaShoppingCart } from "react-icons/fa";
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import logo from '../admin/images/logo.png';
import { IoSearchCircle } from "react-icons/io5";
import { BiCategory } from "react-icons/bi";
import { AiFillHome } from "react-icons/ai";
import { FaShoppingBag } from "react-icons/fa";
import { FaCircleUser } from "react-icons/fa6";
import InstallAppButton from '../user/InstallAppButton';

function NavigationBarUser() {
    const [categoryList, setCategoryList] = useState([]);
    const [loading, setLoading] = useState(true);
    const cartItems = useSelector(state => state.cart.items);
    const navigate = useNavigate();

    const API_URL = process.env.REACT_APP_API_URL;

    // Memoized function to fetch categories
    const getCategories = useCallback(async () => {
        try {
            const response = await axios.get(`${API_URL}/categorydata`);
            if (response.data && Array.isArray(response.data)) {
                setCategoryList(response.data);
            } else {
                console.error("Invalid data format received.");
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoading(false);
        }
    }, [API_URL]);

    useEffect(() => {
        getCategories();
    }, [getCategories]);

    // Memoized cart item count
    const cartCount = useMemo(() => cartItems.length, [cartItems]);

    // Handle Cart Click
    const handleCartClick = (e) => {
        if (cartCount === 0) {
            e.preventDefault();
            toast.success("Cart is empty!", { autoClose: 2000 });
        } else {
            navigate("/mycart");
        }
    };

    return (
        <Fragment>
            <div className="container-fluid g-0 p-0 overflow-hidden">
                <div className="row">
                    <div className="col-12 nav-container shadow-sm z-3 navbar-menu">
                        <button
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasExample"
                            aria-controls="offcanvasExample"
                            aria-label="Toggle navigation"
                        >
                            <GiHamburgerMenu />
                        </button>
                        <div className='logolink'><Link to="/"><img src={logo} alt='logo' className='navigation_logo' height={65} width={100} /></Link></div>
                        <button className="nav-icons" onClick={handleCartClick} aria-label="View Cart">
                            <FaShoppingCart className='me-2'/>
                            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
                        </button>
                    </div>
                </div>
            </div>
            <div
                className="offcanvas offcanvas-start offcanvas-menu"
                tabIndex="-1"
                id="offcanvasExample"
                aria-labelledby="offcanvasExampleLabel"
            >
                <div className="offcanvas-header cat-strip-dark shadow-sm border">
                    <h5 className="offcanvas-title" id="offcanvasExampleLabel">KIPPS SWEETS</h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close menu"
                    ></button>
                </div>
                <div className="offcanvas-body g-0 p-0">
                    <ul className="menu-list">
                        <Link to="/"><li data-bs-dismiss="offcanvas">HOME</li></Link>
                        <Link to="/my-orders"><li data-bs-dismiss="offcanvas">MY ORDERS</li></Link>
                        <Link to="/brand-list"><li data-bs-dismiss="offcanvas">TOP BRANDS</li></Link>
                        <Link to="/about-us"><li data-bs-dismiss="offcanvas">ABOUT KIPPS</li></Link>
                        <Link to="/contact-us"><li data-bs-dismiss="offcanvas">CONTACT US</li></Link>
                        <Link to="/admin"><li data-bs-dismiss="offcanvas">ADMIN LOGIN</li></Link>
                        <InstallAppButton />
                    </ul>
                    <div className="cat-strip-dark shadow-sm border">
                        <h5 className="offcanvas-title">CATEGORIES</h5>
                    </div>
                    <ul className="menu-list">
                        {loading ? <p>Loading categories...</p> :
                            categoryList.length > 0 ? categoryList.map((item, index) => (
                                <Link key={index} to={`/products-by-cat/${item.name}`}>
                                    <li data-bs-dismiss="offcanvas">{item.name.toUpperCase()}</li>
                                </Link>
                            )) : <p>No categories available.</p>
                        }
                    </ul>
                </div>
            </div>
            <div className="footer-mobilebtn">
                <Link to="/"><span> <AiFillHome /></span></Link>
                <Link to="/my-orders"><span> <FaShoppingBag /></span></Link>
                <Link to="/categories"><span> <BiCategory /></span></Link>
                <Link to='/search'><span> <IoSearchCircle /></span></Link>
                <Link to="/my-profile"><span> <FaCircleUser /></span></Link>
            </div>
        </Fragment>
    );
}

export default NavigationBarUser;
